import React, { useState }  from "react";

import { PageButtonsComponent} from './PageButtons';

import { BreadcrumbComponent } from './';

import { BreadCrumbType, PageButtonType, ServiceProgress } from '../../datatypes/datatypes';

import { ipadWidth  } from '../../utils/consts';

import { ColumnType } from './DataTable/DataTypes';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { strings } from "../../services/Localization";
import { IConstants } from "src/types";

declare const constants: IConstants;



interface PageHeaderProp {
    breadCrumbArr?: BreadCrumbType[];
    pageButtons: PageButtonType[];
    countLabel?: string;
    columns?:ColumnType[];
    name?:string;
    scope?:string;
    serviceProgress?: ServiceProgress;
    dataTableView?: string;
    showBreadcrumb?: boolean;
    SELECTALL_BULKACTION_LIMIT?: number; // Bulk action LIMIT
}

interface BulkActionProgress {
    progress: number;
    show: boolean;
}

const PageHeader: React.FC<PageHeaderProp> = ( { breadCrumbArr, pageButtons , countLabel, columns, name, scope, serviceProgress, dataTableView,  showBreadcrumb = true, SELECTALL_BULKACTION_LIMIT } ) => {
    var extraClass = "";
    if(document.body.clientWidth > ipadWidth) {
         extraClass = "justify-content-between";
    }
    
    const [bulkActionProgress, setBulkActionProgress] = useState<BulkActionProgress>({ progress: 0, show: false });

    const handleBulkActionProgress = React.useCallback((progress: number, show: boolean) => {
        setBulkActionProgress(prev => {
            // Auto-hide when progress is 100
            if (progress >= 100) {
                // First show 100% done
                if (prev.progress !== 100 || prev.show !== true) {
                    // Show 100% for a moment
                    setTimeout(() => {
                        setBulkActionProgress({ progress: 100, show: false });
                    }, 1500); // hide after 1.5s (adjust as needed)
                    return { progress: 100, show: true };
                }
                return prev;
            }
            if (prev.progress !== progress || prev.show !== show) {
                return { progress, show };
            }
            return prev;
        });
    }, []);
 
    function getServiceProgressMessage(serviceProgress) {
        const progress = serviceProgress.passed + serviceProgress.failed + serviceProgress.warning;
        const totalDevices = serviceProgress.totalDevices;
        const batchMessage = serviceProgress.totalBatches > 1
            ? strings.BATCH_MESSAGE.replace('{currentBatch}', serviceProgress.currentBatch)
                           .replace('{totalBatches}', serviceProgress.totalBatches)
            : '';
    
        const formattedProgress = progress.toFixed(2);
        return strings.SERVICE_PROGRESS_MESSAGE.replace('{progress}', formattedProgress)
                                       .replace('{totalDevices}', totalDevices)
                                       .replace('{batchMessage}', batchMessage);
    }

    

    return ( 
        <>
            <div className={`row mb-2 mr-0-only d-lg-flex single-page-header ${extraClass} 
            border-2 besides-data-table`} id="page-header" >
                <div className="col-lg-8 col-md-auto col-xs-12">
                   {( <BreadcrumbComponent breadCrumbArr={breadCrumbArr} countLabel={countLabel} name={name}  showBreadcrumb={showBreadcrumb} onProgressChange={handleBulkActionProgress}
                   SELECTALL_BULKACTION_LIMIT={SELECTALL_BULKACTION_LIMIT}
                   />)}
                </div>
                <div  className="col-lg-4 col-md-12 col-xs-12 d-flex flex-sm-row  flex-md-nowrap flex-sm-wrap flex-wrap justify-content-end " 
                >
                    { (constants.server_type === 'dmp') ? null : (<div style={{minWidth:'250px', marginRight:'10px'}}>
                        <div id="extra-search-box"></div>
                    </div>) }
                    
                    <PageButtonsComponent pageButtons={ pageButtons } columns={columns}  scope={scope} dataTableView={dataTableView} />
                </div>
            </div> 
            {serviceProgress && serviceProgress.totalDevices !== undefined && 
            <div>
                 {serviceProgress.totalDevices === 0 ? (
                    <ProgressBar className="custom-progress mx-2" now={2} />
                ) : (
                    <>
                    <ProgressBar className="custom-progress mx-2">
                    <ProgressBar striped variant="success" now={serviceProgress.passed} key={1} />
                    <ProgressBar variant="warning" now={serviceProgress.warning} key={2} />
                    <ProgressBar striped variant="danger" now={serviceProgress.failed} key={3} />
                    </ProgressBar>
                    <div style={{fontSize : '11px'}} className="mx-2">
                        <div className="d-flex justify-content-between">
                            <div className="text-muted"> {getServiceProgressMessage(serviceProgress)}</div>
                        </div>
                    </div>
                    </>
                    
                )} 
            </div>
             }
            {bulkActionProgress.show && (
                <div className="col-12">
                    <div style={{ position: 'relative' }}>
                        <ProgressBar
                            animated
                            now={bulkActionProgress.progress}
                               variant="info"
                            style={{ height: '15px' }}
                        />
                        <span
                            style={{
                                position: 'absolute',
                                left: 0,
                                top: 0,
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '12px',
                                fontWeight: 500,
                                color: '#222',
                                pointerEvents: 'none',
                            }}
                        >
                            {`Progress completed - ${bulkActionProgress.progress < 1 ? bulkActionProgress.progress.toFixed(2) : Math.round(bulkActionProgress.progress)}%`}
                        </span>
                    </div>
                </div>
            )}
            </>
    )    
}

export {  PageHeader };